var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438,
    height: 186,
    viewBox: "0 0 438 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdb4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746e6e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 438,
    height: 186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#9d9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_-_Outline",
    x: 13,
    y: 8,
    width: 171.5,
    height: 171.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.341
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7681",
    "data-name": "Group 7681",
    transform: "translate(4.5 -672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 672)",
    filter: "url(#Rectangle)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 392,
    height: 140,
    rx: 10,
    transform: "translate(23 21)",
    stroke: "#ff3535",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Fundraiser",
    transform: "translate(171.5 760)",
    fill: "#fff",
    fontSize: 41,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Activate"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 28,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "Emergency Alert"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(38.5 708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 103,
    height: 103,
    rx: 51.5,
    transform: "translate(4 4.5)",
    fill: "#7f7979"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43, -36)",
    filter: "url(#Rectangle_-_Outline)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_-_Outline-2",
    "data-name": "Rectangle - Outline",
    d: "M51.75-4A55.75,55.75,0,1,1-4,51.75,55.813,55.813,0,0,1,51.75-4Zm0,103.241A47.491,47.491,0,1,0,4.259,51.75,47.545,47.545,0,0,0,51.75,99.241Z",
    transform: "translate(47 40)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "click",
    transform: "translate(35.565 27.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M40.333,77.232A4.643,4.643,0,0,0,36.726,72.8a5.107,5.107,0,0,0-2.821.142,4.9,4.9,0,0,0-6.346-3.1,4.9,4.9,0,0,0-6.073-3.018V66.2c0-1.506.023-3.013-.009-4.518a4.78,4.78,0,1,0-9.554.34q-.011,9.852,0,19.7v.566a27.207,27.207,0,0,1-1.683-2.307A5.619,5.619,0,0,0,.862,86.172Q5.013,92.812,9.251,99.4a10.5,10.5,0,0,0,5.137,4.206,31.013,31.013,0,0,0,3.4.907H29.218a4.513,4.513,0,0,1,.473-.1A12.208,12.208,0,0,0,40.206,94.1a34.317,34.317,0,0,0,.145-4.019c.013-4.281.029-8.564-.019-12.846ZM37.089,92.087a8.891,8.891,0,0,1-6.729,8.859,9.312,9.312,0,0,1-2.2.286c-3.12.03-6.241.045-9.361,0a7.975,7.975,0,0,1-6.964-3.859C9.1,93.119,6.4,88.84,3.7,84.566A2.353,2.353,0,0,1,5.46,80.845a2.268,2.268,0,0,1,2.165,1.1q3.565,5.3,7.137,10.6c.1.15.208.295.311.441l.113-.023v-.636q0-15,0-29.99a3.981,3.981,0,0,1,.065-.864,1.478,1.478,0,0,1,1.559-1.161,1.524,1.524,0,0,1,1.4,1.365,5.867,5.867,0,0,1,.012.6V78.1h3.267v-.573c0-2.014-.007-4.027,0-6.041a1.515,1.515,0,1,1,3.027-.051c.009.145,0,.29,0,.436V78.11h3.239c.009-.174.025-.364.025-.555,0-1.034-.006-2.069,0-3.1a1.509,1.509,0,1,1,3.013-.071c.033,1.034.01,2.067.012,3.1v.629h3.233c.016-.261.025-.528.048-.793a1.495,1.495,0,0,1,2.983.02c.012.144.013.29.013.436,0,4.772.012,9.543,0,14.315Z",
    transform: "translate(0.006 -48.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M106.3,0H103.03V4.482H106.3Z",
    transform: "translate(-88.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M56.013,16.619,52.971,13.28l-2.411,2.2,3.04,3.335Z",
    transform: "translate(-43.219 -11.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M164.311,65.783l4.49-.412c-.1-1.1-.2-2.149-.3-3.251l-4.495.42c.1,1.1.2,2.121.3,3.243Z",
    transform: "translate(-140.198 -53.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M36.074,62.491l-4.488-.421c-.1,1.119-.2,2.17-.3,3.255l4.49.412c.1-1.108.195-2.157.292-3.245Z",
    transform: "translate(-26.746 -53.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M145.66,15.481l-2.411-2.2c-1.037,1.141-2.03,2.234-3.039,3.344l2.41,2.2,3.039-3.338Z",
    transform: "translate(-119.853 -11.352)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGrey);
export default __webpack_public_path__ + "static/media/title_grey.aca5e1e59e4feeac4d70746c68d1f58d.svg";
export { ForwardRef as ReactComponent };